import React, { useState } from "react";
import CustomDialog from "../../common/Dialog";
import { useStyles } from "../Users.styles";
import TotpSteps from "./totp";
import { useDispatch } from "react-redux";
import { verifyOTP, DisableTOTP } from "../redux/usersSlice";
import { useSelector } from "react-redux";
import { AppState } from "config/redux/reducers";
import AppConstants from "../../constants/index";
import { TextConstants } from "constants/TextConstants";

const TOTP_STEPS = AppConstants.USERS_CONSTANTS.TOTP_STEPS;
export interface Step {
  id: typeof TOTP_STEPS.IDS[keyof typeof TOTP_STEPS.IDS];
  type: typeof TOTP_STEPS.TYPES[keyof typeof TOTP_STEPS.TYPES];
  message?: string;
  showContinue?: boolean;
  onContinue?: (data: {
    otp: string;
  }) => { nextStep?: string } | Promise<{ nextStep?: string }>;
  showDone?: boolean;
  showResend?: boolean;
  onDone?: () => void;
}

const Totp = (props: {
  open: boolean;
  closePopup: () => void;
  user: any;
  isTotpSwitchEnabled: boolean;
  setIsTotpSwitchEnabled: (value: boolean) => void;
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { scanner, errorMsgOtp } = useSelector(
    (state: AppState) => state.users
  );

  const {
    open,
    closePopup,
    user,
    isTotpSwitchEnabled,
    setIsTotpSwitchEnabled,
  } = props;
  const [currentStepId, setCurrentStepId] = useState<string>("");

  const otpDialogPaperProps = {
    classes: { root: classes.customDialogOTPPaperPropsRoot },
  };

  const commonSteps: Step[] = [
    {
      id: TOTP_STEPS.IDS.OTP,
      type: TOTP_STEPS.TYPES.OTP,
      showContinue: true,
      onContinue: async ({ otp }) => {
        try {
          let result;
          if (isTotpSwitchEnabled) {
            // Call a different API when isSwitchOn is true
            result = await dispatch(verifyOTP({ username: user?.email, otp })); // Replace with the correct action
          } else {
            // Call the default API
            result = await dispatch(
              DisableTOTP({ username: user?.email, otp })
            ); // Use unwrap() for thunk
          }
          if (result.payload.error) {
            return { nextStep: TOTP_STEPS.IDS.ERROR };
          } else {
            return { nextStep: TOTP_STEPS.IDS.SUCCESS };
          }
        } catch (error) {
          return { nextStep: TOTP_STEPS.IDS.ERROR };
        }
      },
    },
    {
      id: TOTP_STEPS.IDS.SUCCESS,
      type: TOTP_STEPS.TYPES.MESSAGE,
      message: isTotpSwitchEnabled
        ? TextConstants.OTP_SUCCESS_HEADING
        : TextConstants.OTP_SUCCESS_HEADING2,
      showDone: true, // Done button instead of Continue
      onDone: () => {
        closePopup();
      },
    },
    {
      id: TOTP_STEPS.IDS.ERROR,
      type: TOTP_STEPS.TYPES.MESSAGE,
      message: errorMsgOtp,
      showDone: true, // Done button to close
      onContinue: async () => {
        return { nextStep: TOTP_STEPS.IDS.OTP }; // Reset to initial step
      },
      onDone: () => {
        closePopup();
      },
    },
  ];

  const fullFlowSteps: Step[] = [
    {
      id: TOTP_STEPS.IDS.SCANNER,
      type: TOTP_STEPS.TYPES.SCANNER,
      showContinue: true,
      onContinue: () => Promise.resolve({ nextStep: TOTP_STEPS.IDS.OTP }),
    },
    ...commonSteps,
  ];

  const steps = isTotpSwitchEnabled ? fullFlowSteps : commonSteps;

  const handleDialogClose = () => {
    if (currentStepId !== TOTP_STEPS.IDS.SUCCESS) {
      setIsTotpSwitchEnabled(!isTotpSwitchEnabled); // Reset in parent if not on success
    }
    closePopup();
  };

  const getDetailsContent = () => {
    return (
      <TotpSteps
        steps={steps}
        scanner={scanner}
        isTotpSwitchEnabled={isTotpSwitchEnabled}
        onStepChange={setCurrentStepId}
      />
    );
  };

  return (
    <CustomDialog
      open={open}
      PaperProps={otpDialogPaperProps}
      title={<></>}
      content={getDetailsContent()}
      handleClose={handleDialogClose}
      hideCloseIcon={true}
    />
  );
};

export default Totp;
